import { codeFromCountryAcronym } from 'Components/Forms/CountryCodeSelect';

// The login service knows a phone account by its full international number:
// "+", the country's calling code, then the number's digits. The forms accept
// spaces, dashes, dots and parentheses between the digits, so everything that
// is not a digit is dropped before the number is sent. (MUS-631)
export const phoneDigits = (typedNumber: string): string => typedNumber.replace(/\D/g, '');

export const phoneUsername = (typedNumber: string, countryAcronym: string): string =>
  `+${codeFromCountryAcronym(countryAcronym)}${phoneDigits(typedNumber)}`;
